import { render, staticRenderFns } from "./manage-dynamic-groups.vue?vue&type=template&id=31bcea07&scoped=true"
import script from "./manage-dynamic-groups.vue?vue&type=script&lang=js"
export * from "./manage-dynamic-groups.vue?vue&type=script&lang=js"
import style0 from "./manage-dynamic-groups.vue?vue&type=style&index=0&id=31bcea07&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bcea07",
  null
  
)

export default component.exports